import { useMutation, useQueryClient } from "@tanstack/react-query";

import { useAuth } from "../../../shared/contexts/auth/useAuth.ts";
import { useQueries } from "../../../shared/hooks/useQueries.ts";
import { connectSessionStore } from "../state/connect-session.ts";

// oxlint-disable-next-line @typescript-eslint/explicit-function-return-type
export function useGithubActions() {
  const { api } = useAuth();

  const queryClient = useQueryClient();

  const { getGithubConnectionsQueryOptions } = useQueries();

  const connect = useMutation({
    mutationFn: async () => {
      const session = connectSessionStore.startSession();

      return api.github.getInstallUrl({ session });
    },
    onSuccess: ({ installUrl }) => {
      window.location.href = installUrl;
    },
  });

  const disconnect = useMutation({
    mutationFn: api.github.disconnect,
    onSuccess: async () => {
      const githubConnectionsQueryOptions = getGithubConnectionsQueryOptions();

      await queryClient.invalidateQueries({
        queryKey: githubConnectionsQueryOptions.groupQueryKey,
      });
    },
  });

  return { connect, disconnect };
}
